<div class="title">
  <mat-icon>sell</mat-icon>
  Tags
</div>
<div class="description">SELECT THE TAGS TO FILTER BY</div>

<div class="options">
  @for (tag of tags$ | async; track tag) {
    <elements-filter-chip
      icon="sell"
      [caption]="tag.name"
      [selected]="isSelected(tag)"
      (click)="isSelected(tag) ? remove(tag) : add(tag)"
      suffixIcon="close"
      >
    </elements-filter-chip>
  }
</div>

<div class="actions">
  <button styles-button (click)="close.emit()">Filter</button>
  <button styles-low-button (click)="clear()">Clear</button>
</div>
